
@switch (columnId) {
  @case ('mid') {
    <lib-text-table-column>
      {{ element.mid }}
    </lib-text-table-column>
  }
  @case ('dba') {
    <lib-text-table-column>
      {{ element.dba }}
    </lib-text-table-column>
  }
  @case ('processor') {
    <lib-text-table-column>
      {{ element.processor }}
    </lib-text-table-column>
  }
  @case ('isServiceFee') {
    <lib-binary-status-icon
      [value]="element?.isServiceFee"
      [showPositiveOnly]="true">
    </lib-binary-status-icon>
    <lib-table-column-sort [key]="element.isServiceFee ? 1 : 0"></lib-table-column-sort>
  }
  @case ('deletedUtc') {
    @if (showingDeletedMids) {
      <lib-date-time-label [dateUtc]="element?.deletedUtc">
      </lib-date-time-label>
      <lib-table-column-sort [key]="sortingKeyForDateDeleted"></lib-table-column-sort>
    }
  }
  @default {
  }
}
